/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { Currency } from './Currency';
import { TaxBehavior } from './TaxBehavior';
const PutPerCoursePriceTenantDataParser = 
/* #__PURE__ */ parsers.object([
    ['currency', Currency],
    ['amount', parsers.decimal],
    ['refundPeriod', parsers.duration, 'refund_period'],
    ['taxBehavior', TaxBehavior, 'tax_behavior'],
]);
export class PutPerCoursePriceTenantData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return PutPerCoursePriceTenantDataParser.decode(input).map(res => new PutPerCoursePriceTenantData(res));
    }
    static unsafeDecode(input) {
        return PutPerCoursePriceTenantData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return PutPerCoursePriceTenantDataParser.encode(data);
    }
    static schema() {
        return PutPerCoursePriceTenantDataParser.schema();
    }
}
